export default [
	{  // 代理账户收支记录
		path: 'member_account_record',
		name: 'm_member_account_record',
		component: () => import('@/pages/finance/member_account_record_list')
	}, {  // 代理账户收支记录详情
		path: 'member_account_record_detail/:id',
		name: 'member_account_record_detail',
		meta: {
			title: '代理收支记录详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_record_detail')
	}, {  // 授信账单列表
		path: 'member_account_credit_info',
		name: 'm_finance_member_credit_info',
		props: route => route.query,
		component: () => import('@/pages/finance/member_account_credit_info_list')
	},  {  // 授信账单详情
		path: 'member_account_credit_info_detail/:id',
		name: 'member_account_credit_info_detail',
		meta: {
			title: '授信账单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_credit_info_detail')
	}, {  //货款补扣款
		path: 'member_account_supdeduct',
		name: 'm_member_account_supdeduct',
		component: () => import('@/pages/finance/member_account_supdeduct_list')
	}, {  //货款补扣款详情
		path: 'member_account_supdeduct_detail/:id',
		name: 'member_account_supdeduct_detail',
		meta: {
			title: '代理补扣款详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_supdeduct_detail')
	}, {  // 佣金补扣款
		path: 'member_reward_supdeduct',
		name: 'm_member_reward_supdeduct',
		component: () => import('@/pages/finance/member_reward_supdeduct_list')
	}, {  // 佣金补扣款详情
		path: 'member_reward_supdeduct_detail/:id',
		name: 'member_reward_supdeduct_detail',
		meta: {
			title: '佣金补扣款详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_reward_supdeduct_detail')
	}, {  // 积分补扣款
		path: 'member_points_supdeduct',
		name: 'm_member_points_supdeduct',
		component: () => import('@/pages/finance/member_points_supdeduct_list')
	}, {  // 积分补扣款详情
		path: 'member_points_supdeduct_detail/:id',
		name: 'member_points_supdeduct_detail',
		meta: {
			title: '积分补扣详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_points_supdeduct_detail')
	}, {  // 代理提现
		path: 'member_account_extract',
		name: 'm_member_account_extract',
		component: () => import('@/pages/finance/member_account_extract_list')
	}, {  // 代理提现详情
		path: 'member_account_extract_detail/:id',
		name: 'member_account_extract_detail',
		meta: {
			title: '代理提现详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/member_account_extract_detail')
	}, {  // 商家账户收支记录
		path: 'stationed_account_record',
		name: 'm_stationed_account_record',
		props: route => route.query,
		component: () => import('@/pages/finance/stationed_account_record_list')
	}, {  // 商家账户收支记录详情
		path: 'stationed_account_record_detail/:id',
		name: 'stationed_account_record_detail',
		meta: {
			title: '商家收支记录详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/stationed_account_record_detail')
	}, {  // 商家补扣款
		path: 'stationed_account_supdeduct',
		name: 'm_stationed_account_supdeduct',
		component: () => import('@/pages/finance/stationed_account_supdeduct_list')
	}, {  // 商家补扣款详情
		path: 'stationed_account_supdeduct_detail/:id',
		name: 'stationed_account_supdeduct_detail',
		meta: {
			title: '商家补扣款详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/stationed_account_supdeduct_detail')
	}, {  // 商家提现
		path: 'stationed_account_extract',
		name: 'm_stationed_account_extract',
		component: () => import('@/pages/finance/stationed_account_extract_list')
	}, {  // 商家提现详情
		path: 'stationed_account_extract_detail/:id',
		name: 'stationed_account_extract_detail',
		meta: {
			title: '商家提现详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/stationed_account_extract_detail')
	}, {  // 系统账户管理
		path: 'sys_account',
		name: 'm_finance_sys_account',
		component: () => import('@/pages/finance/sys_account')
	}, {  // 授权额度管理
		path: 'credit_quota',
		name: 'm_credit_quota',
		props: route => route.query,
		component: () => import('@/pages/finance/credit_quota')
	},{  // 授权额度管理详情
		path: 'credit_quota_detail/:id',
		name: 'credit_quota_detail',
		meta: {
			title: '授权额度管理详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/credit_quota_detail')
	}, {  // 系统账户收支流水
		path: 'sys_account_record/:id',
		name: 'm_finance_sys_account_record',
		meta: {
			title: '系统账户收支流水'
		},
		props: route => route.query,
		component: () => import('@/pages/finance/sys_account_record')
	}, {  //分销清分列表
		path: 'reward',
		name: 'm_reward_settlement',
		component: () => import('@/pages/finance/reward_record_list')
	}, {  //分销清分详情
		path: 'reward/detail/:orderNumber',
		name: 'reward_record_detail',
		meta: {
			title: '分销清分详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/reward_record_detail')
	}, {  // 订单清分列表
		path: 'settlement',
		name: 'm_order_settlement',
		component: () => import('@/pages/finance/order_settlement_list')
	}, {  //订单清分详情
		path: 'settlement/detail/:orderNumber',
		name: 'order_settlement_detail',
		meta: {
			title: '订单清分详情'
		},
		props: route => route.params,
		component: () => import('@/pages/finance/order_settlement_detail')
	}, {  // 财务配置
		path: 'finance_config',
		name: 'm_finance_config',
		component: () => import('@/pages/finance/finance_config')
	}, {  // 清分明细列表
		path: 'settlement_detail_list',
		name: 'm_settlement_detail',
		component: () => import('@/pages/finance/settlement_detail_list')
	}
];